<template>
  <span :class="classnames">
    <span :class="`${ns}__text`">
      <template v-if="id">
        <span :class="`${ns}__type`">
          {{ type }}
        </span>
      </template>

      <span :class="`${ns}__title`">
        <slot>Tag</slot>
      </span>
    </span>

    <button
      :class="`${ns}__button`"
      :data-id="`${id}`"
      :type="`button`"
      @click="handleClick"
    >
      Remove
    </button>
  </span>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'active-filters-list-item'

  export default {
    name: 'ActiveFiltersListItem',
    mixins: [ bem ],
    props: {
      extraClassname: {
        type: String
      },
      id: {
        type: String
      }
    },
    data: function () {
      return {}
    },
    computed: {
      type: function () {
        // NOTE
        // it'd be nice to have the "tag type" returned from
        // the api, rather than using the "id" this way
        //
        // example:
        // "option.e8ed002412e8" => "option"
        let type = this.id.split('.')[0]

        // mutate
        type = type.replace('_', ' ')

        return type
      }
    },
    created: function () {
      this.setNamespace(namespace)
    },
    methods: {
      handleClick: function (event) {
        this.$emit('click', event)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ActiveFiltersListItem.vue